import { useEffect, useState } from "react";
import { Search, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { publicNavigation } from "./navigation";
import { API, usePublicData } from "./siteData";
import { newsLink, academyGroupLink } from "../utils/playerHelpers";

const normalize = value => (value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase("el");
export const SiteSearch = () => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);
  const { groups } = usePublicData();
  useEffect(() => {
    if (!open) return;
    let active = true;
    setLoading(true); setFailed(false);
    axios.get(`${API}/news?limit=100`).then(r => { if (active) setNews(r.data); }).catch(() => { if (active) setFailed(true); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [open]);
  const links = publicNavigation.flatMap(item => item.items ? item.items.map(([id, label, path]) => ({ id: `${item.id}-${id}`, label, path })) : [item]);
  const all = [...links, ...groups.map(g => ({ id: g.id, label: `Ακαδημία · ${g.name}`, path: academyGroupLink(g) })), ...news.map(n => ({ id: n.id, label: n.title, path: newsLink(n) }))];
  const results = all.filter((item, i) => all.findIndex(x => x.path === item.path) === i && normalize(item.label).includes(normalize(query))).slice(0, 16);
  return <>
    <button className="public-search-trigger" type="button" onClick={() => setOpen(true)} aria-label="Αναζήτηση" data-testid="public-search-open"><Search size={19} /><span>Αναζήτηση…</span></button>
    <Dialog open={open} onOpenChange={setOpen}><DialogContent className="public-dialog public-search-dialog" closeTestId="public-search-close" closeLabel="Κλείσιμο αναζήτησης" data-testid="public-search-dialog">
      <DialogTitle>ΑΝΑΖΗΤΗΣΗ</DialogTitle><DialogDescription>Νέα, ομάδες και σελίδες του συλλόγου</DialogDescription>
      <label className="sr-only" htmlFor="public-search">Αναζήτηση</label><input autoFocus id="public-search" value={query} onChange={e => setQuery(e.target.value)} placeholder="Τι αναζητάς;" data-testid="public-search-input" />
      {loading && <p role="status" data-testid="public-search-loading">Φόρτωση νέων…</p>}
      {failed && <p role="alert" data-testid="public-search-error">Τα νέα δεν είναι προσωρινά διαθέσιμα στην αναζήτηση.</p>}
      <div className="public-search-results" data-testid="public-search-results">{results.map(item => <Link key={item.id} to={item.path} onClick={() => setOpen(false)} data-testid={`public-search-result-${item.id}`}>{item.label}<ArrowUpRight size={17} /></Link>)}</div>
      {!loading && !results.length && <p data-testid="public-search-empty">Δεν βρέθηκαν αποτελέσματα.</p>}
    </DialogContent></Dialog>
  </>;
};